<template>
	<div class="detail-form">
		<div class="row" v-show="!isLoadingAdmins">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="first_name">Nome do Administrador: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.firstName ? 'alert' : '']"
					id="first_name"
					type="text"
					placeholder="Nome do Administrador"
					v-model="admin.firstName"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.firstName">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="last_name">Sobrenome do Administrador: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.lastName ? 'alert' : '']"
					id="last_name"
					type="text"
					placeholder="Sobrenome do Administrador"
					v-model="admin.lastName"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.lastName">
					Campo obrigatório.
				</small>
			</div>
		</div>
		<div class="row" v-show="!isLoadingAdmins">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="email">E-mail: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.email ? 'alert' : '']"
					id="email"
					type="text"
					placeholder="nome@bamboo.com.br"
					v-model="admin.email"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.email">
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="phone">Telefone: *</label>
				<input
					class="detail-form__field--input"
					:class="[requiredFields.phone ? 'alert' : '']"
					id="phone"
					type="text"
					placeholder="(00) 00000-0000"
					v-mask="'(##) #####-####'"
					v-model="admin.phone"
				/>
				<small class="detail-form__field--input--required" v-if="requiredFields.phone">
					Campo obrigatório.
				</small>
			</div>
		</div>
		<div class="row" v-show="!isLoadingAdmins">
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="password">Senha: *</label>
				<InputPassword
					id="password-input"
					v-model="admin.password"
					class="detail-form__field--input"
					:alertClass="requiredFields.password && newAdmin"
					:adminDetail="true"
					@clearRequired="requiredFields.password = false"
				/>
				<small
					class="detail-form__field--input--required"
					v-if="requiredFields.password && newAdmin"
				>
					Campo obrigatório.
				</small>
			</div>
			<div class="detail-form__field">
				<label class="detail-form__field--label" for="confirm_password">Confirmar Senha: *</label>
				<InputPassword
					id="password-input"
					v-model="confirmPassword"
					class="detail-form__field--input"
					:alertClass="requiredFields.confirmPassword && newAdmin"
					:adminDetail="true"
					@clearRequired="requiredFields.confirmPassword = false"
				/>
				<small
					class="detail-form__field--input--required"
					v-if="requiredFields.confirmPassword && newAdmin"
				>
					Campo obrigatório.
				</small>
			</div>
		</div>
		<div class="detail-form__actions" :class="newAdmin ? 'new-user' : ''" v-show="!isLoadingAdmins">
			<button
				class="detail-form__actions--btn outline"
				@click="handleDeleteModal()"
				v-if="!newAdmin"
			>
				Excluir Administrador
			</button>
			<button class="detail-form__actions--btn" @click="validateFields()">Salvar</button>
		</div>
		<div class="row justify-center align-center w-90-vw h-70-vh" v-if="isLoadingAdmins">
			<SpinnerIcon />
		</div>
		<DeleteModal
			:title="'Excluir Administrador'"
			:subtitle="'Tem certeza que deseja excluir este Administrador?'"
			:loader="isLoadingAdmins"
			v-show="showDeleteModal"
			@handleDeleteModal="handleDeleteModal()"
			@confirmDelete="confirmDelete()"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
	GET_ADMIN_BY_ID,
	CREATE_ADMIN,
	UPDATE_ADMIN,
	DELETE_ADMIN,
} from '@/store/modules/configManagement/actions';
import { mask } from 'vue-the-mask';
import CryptoJS from 'crypto-js';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';
import DeleteModal from '@/components/shared/DeleteModal/DeleteModal.vue';
import InputPassword from '@/components/shared/InputPassword/InputPassword.vue';

export default {
	name: 'AdminForm',
	directives: { mask },
	components: { SpinnerIcon, DeleteModal, InputPassword },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		admin: {
			firstName: '',
			lastName: '',
			email: '',
			phone: '',
			password: '',
		},
		requiredFields: {
			firstName: false,
			lastName: false,
			email: false,
			phone: false,
			password: false,
			confirmPassword: false,
		},
		confirmPassword: '',
		newAdmin: false,
		isEditing: false,
		showDeleteModal: false,
	}),
	created() {},
	mounted() {
		if (this.$route.query.id) {
			this.getAdmin({ vm: this, id: this.$route.query.id }).then((res) => {
				const selectedAdmin = res.data;

				this.admin.firstName = selectedAdmin.firstName;
				this.admin.lastName = selectedAdmin.lastName;
				this.admin.email = selectedAdmin.email;
				this.admin.phone = selectedAdmin.phone;
			});
		} else {
			this.newAdmin = true;
		}
	},
	methods: {
		...mapActions('configManagement', {
			getAdmin: GET_ADMIN_BY_ID,
			createNewAdmin: CREATE_ADMIN,
			updateAdmin: UPDATE_ADMIN,
			deleteInvestor: DELETE_ADMIN,
		}),
		changeStatusInput(param) {
			this.admin.hasNDA = param.value.id;
		},
		handleDeleteModal() {
			this.showDeleteModal = !this.showDeleteModal;
		},
		confirmDelete() {
			this.deleteInvestor({ vm: this, id: this.$route.query.id })
				.then((res) => {
					this.handleDeleteModal();
					if (res.status == 200) {
						this.$router.push({ path: '/dashboard/admins' });
					}
				})
				.catch((e) => {
					this.handleDeleteModal();
				});
		},
		createAdmin() {
			let body = JSON.stringify(this.admin);
			body = JSON.parse(body);

			const fixedKey = process.env.VUE_APP_FIXED_KEY;
			const getEmailChars = body.email.substring(0, 4);

			let timestamp = new Date().toISOString();
			let formatHour = this.$moment(new Date(timestamp)).format('HH:mm:ss');
			formatHour = formatHour.replace(/:/g, '');

			const key = `${fixedKey}${getEmailChars}${formatHour}`;
			const encryptedPassword = CryptoJS.AES.encrypt(body.password, key);

			body['password'] = encryptedPassword.toString();

			this.createNewAdmin({ vm: this, body: body, timestamp: timestamp }).then((res) => {
				if (res.status == 201) {
					this.$router.push({ path: '/dashboard/admins' });
				}
			});
		},
		confirmUpdate() {
			let body = JSON.stringify(this.admin);
			body = JSON.parse(body);

			let timestamp = new Date().toISOString();
			let formatHour = this.$moment(new Date(timestamp)).format('HH:mm:ss');
			formatHour = formatHour.replace(/:/g, '');

			if (body.password) {
				const fixedKey = process.env.VUE_APP_FIXED_KEY;
				const getEmailChars = body.email.substring(0, 4);

				const key = `${fixedKey}${getEmailChars}${formatHour}`;
				const encryptedPassword = CryptoJS.AES.encrypt(body.password, key);

				body['password'] = encryptedPassword.toString();
			} else {
				delete body['password'];
			}

			this.updateAdmin({
				vm: this,
				id: this.$route.query.id,
				body: body,
				timestamp: timestamp,
			}).then((res) => {
				if (res.status == 200) {
					this.isEditing = false;
				}
			});
		},
		validateEmail(email) {
			let emailRegex = /\S+@\S+\.\S+/;
			return emailRegex.test(email);
		},
		validateFields() {
			this.requiredFields = {
				firstName: true,
				lastName: true,
				email: true,
				phone: true,
				password: true,
				confirmPassword: true,
			};

			if (this.admin.firstName) this.requiredFields.firstName = false;
			if (this.admin.lastName) this.requiredFields.lastName = false;
			if (this.admin.email) this.requiredFields.email = false;
			if (this.admin.phone) this.requiredFields.phone = false;
			if (this.admin.password) this.requiredFields.password = false;
			if (this.confirmPassword) this.requiredFields.confirmPassword = false;
			if (this.admin.password != this.confirmPassword)
				return this.$toastr.e('As senhas precisam ser iguais.');

			if (!this.validateEmail(this.admin.email)) return this.$toastr.e('Email inválido.');

			if (
				!this.admin.firstName ||
				!this.admin.lastName ||
				!this.admin.email ||
				!this.admin.phone ||
				(!this.admin.password && this.newAdmin) ||
				(!this.confirmPassword && this.newAdmin)
			) {
				return;
			}

			if (!this.newAdmin) {
				this.confirmUpdate();
			} else {
				this.createAdmin();
			}
		},
	},
	computed: {
		...mapGetters('configManagement', ['isLoadingAdmins']),
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'AdminForm.scss';
</style>
